import HowMuch from '../img/HowMuch.png';

const BeefNeed = () => {
    return (
        <img src={HowMuch} className='how-much' />
    );
};

export default BeefNeed;